function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var WorkspaceTemplate = require('./workspace.template');
var FieldOverlay = require('./overlays/field');
var IdentityPrompt = require('./overlays/identity');
var SignOverlay = require('./overlays/sign');
var ClosePrompt = require('./overlays/close');
var SignerOverlay = require('./overlays/signer');
var PublishOverlay = require('./overlays/publish');
var _require = require('../document'),
  ACTION_TYPES = _require.ACTION_TYPES,
  addUser = _require.addUser,
  resolveSigner = _require.resolveSigner,
  renameUser = _require.renameUser,
  removeUser = _require.removeUser,
  addAction = _require.addAction,
  actionById = _require.actionById,
  removeAction = _require.removeAction,
  actionsOnPage = _require.actionsOnPage,
  stripSignatures = _require.stripSignatures,
  emptyDocument = _require.emptyDocument,
  revoke = _require.revoke,
  hasPdf = _require.hasPdf,
  pdfEntries = _require.pdfEntries,
  pageSource = _require.pageSource,
  isPdf = _require.isPdf,
  openPdfs = _require.openPdfs;
var _require2 = require('../auth'),
  addInitial = _require2.addInitial,
  addSignature = _require2.addSignature,
  verifiedMethods = _require2.verifiedMethods,
  verifyActionSignature = _require2.verifyActionSignature,
  commitmentIntact = _require2.commitmentIntact,
  documentFullyVerified = _require2.documentFullyVerified,
  verificationSatisfied = _require2.verificationSatisfied,
  createCreatorProof = _require2.createCreatorProof;
function walletKeys(app) {
  var _app$wallet, _app$crypto;
  var raw = String(((_app$wallet = app.wallet) === null || _app$wallet === void 0 ? void 0 : _app$wallet.publicKey) || '').trim();
  var keys = [];
  if (raw) {
    keys.push(raw);
  }
  if (/^[0-9a-fA-F]+$/.test(raw) && raw.length >= 64 && (_app$crypto = app.crypto) !== null && _app$crypto !== void 0 && _app$crypto.compressPublicKey) {
    var compressed = app.crypto.compressPublicKey(raw);
    if (compressed && !keys.includes(compressed)) {
      keys.push(compressed);
    }
  }
  return keys;
}
function canConfigure(app, record) {
  var _record$creatorProof;
  if (!record || record.finalized || !record.creator || !((_record$creatorProof = record.creatorProof) !== null && _record$creatorProof !== void 0 && _record$creatorProof.signature)) {
    return false;
  }
  return walletKeys(app).includes(String(record.creator).trim());
}
function canSignAction(app, action, user, record) {
  if (!action || !user) {
    return false;
  }
  if (action.type !== 'signature' && action.type !== 'initial') {
    return false;
  }
  if (verifyActionSignature(app, action, user, record)) {
    return false;
  }
  var theirs = String(user.publickey || '').trim();
  if (!theirs || !walletKeys(app).includes(theirs)) {
    return false;
  }
  return verificationSatisfied(app, record, user);
}
var MIN_DRAG = 12;
var CLICK_WIDTH = 0.221;
var CLICK_HEIGHT = 0.033;
var MIN_BOX_WIDTH = 0.025;
var MIN_BOX_HEIGHT = 0.025;
var ZOOM_MIN = 1;
var SIGNER_COLORS = ['#e85d04', '#1d7874', '#315a9b', '#9b2226', '#6a4c93', '#0a7ea4', '#bc6c25', '#2d6a4f'];
var ZOOM_MAX = 3;
var ZOOM_STEP = 1.35;
var SIGN_CONFIRM_MS = 500;
var Workspace = /*#__PURE__*/function () {
  function Workspace(app, mod) {
    _classCallCheck(this, Workspace);
    this.app = app;
    this.mod = mod;
    this.page = 1;
    this.notice = '';
    this.placing = false;
    this.adding_signer = false;
    this.focus_name = false;
    this.draft = null;
    this.focus_field = null;
    this.confirming_field = null;
    this.sign_step = 0;
    this.sign_timer = null;
    this.sign_wait = null;
    this.sign_scroll_wait = null;
    this.sign_lock = false;
    this.intent = null;
    this.arming = false;
    this.drag = null;
    this.resize = null;
    this.arrived = null;
    this.overlay = null;
    this.publish = new PublishOverlay(app, mod);
    this.listening = false;
    this.pending_scroll = false;
    this.scroll_field = null;
    this.suspend_scroll = false;
    this.zoom = ZOOM_MIN;
    this.reader_moved = false;
    this.reader_x = 16;
    this.reader_y = 16;
    this.reader_drag = null;
    this.reader_expanded = false;
    this.field_type = '';
  }
  return _createClass(Workspace, [{
    key: "show",
    value: function show() {
      this.page = 1;
      this.notice = '';
      this.placing = false;
      this.adding_signer = false;
      this.focus_name = false;
      this.draft = null;
      this.cancelSignSequence();
      this.intent = null;
      this.arming = false;
      this.drag = null;
      this.resize = null;
      this.arrived = null;
      this.pending_scroll = false;
      this.scroll_field = null;
      this.zoom = ZOOM_MIN;
      this.reader_moved = false;
      this.reader_x = 16;
      this.reader_y = 16;
      this.reader_expanded = false;
      this.field_type = '';
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      var container = document.querySelector('.saito-container');
      var doc = this.mod.document;
      if (!container || !hasPdf(doc)) {
        return;
      }
      container.classList.add('saitosign');
      var src = pdfEntries(doc).map(function (entry) {
        return entry.url || '';
      }).join('|');
      var root = container.querySelector(':scope > .workspace');
      if (!root || root.dataset.src !== src) {
        container.innerHTML = WorkspaceTemplate(this.view());
        root = container.querySelector(':scope > .workspace');
        root.dataset.src = src;
        this.attachEvents(root);
      } else {
        this.update(root);
        return;
      }
      this.fitSheet(root);
      root.querySelector('.reader').innerHTML = WorkspaceTemplate.reader(this.view());
      this.loadPages(root);
      this.listen();
    }
  }, {
    key: "update",
    value: function update(root) {
      var _root$querySelector;
      var view = this.view();
      root.querySelector('.rail').innerHTML = WorkspaceTemplate.rail(view);
      (_root$querySelector = root.querySelector(':scope > .actions-col')) === null || _root$querySelector === void 0 || _root$querySelector.remove();
      this.paintFields(root, view);
      if (this.focus_name) {
        var _root$querySelector2;
        (_root$querySelector2 = root.querySelector('[data-signer-name]')) === null || _root$querySelector2 === void 0 || _root$querySelector2.focus();
        this.focus_name = false;
      }
      this.fitSheet(root);
      root.querySelector('.reader').innerHTML = WorkspaceTemplate.reader(this.view());
      this.loadPages(root);
      if (this.pending_scroll) {
        this.pending_scroll = false;
        var fieldId = this.scroll_field;
        this.scroll_field = null;
        if (fieldId) {
          this.scrollToField(root, fieldId);
        } else {
          this.scrollToPage(root, this.page);
        }
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(root) {
      var _this = this;
      root.addEventListener('click', function (event) {
        if (_this.suppress_click) {
          _this.suppress_click = false;
          return;
        }
        var doc = _this.mod.document;
        if (!doc) {
          return;
        }
        if (event.target.closest('[data-add-signer]')) {
          if (!canConfigure(_this.app, doc)) return;
          _this.adding_signer = true;
          _this.focus_name = true;
          _this.placing = false;
          _this.update(root);
          return;
        }
        if (_this.adding_signer && !event.target.closest('.add-signer')) {
          _this.adding_signer = false;
          _this.update(root);
          return;
        }
        var signer_row = event.target.closest('[data-open-signer]');
        if (signer_row) {
          _this.openSigner(Number(signer_row.dataset.openSigner));
          return;
        }
        if (event.target.closest('[data-add-field]')) {
          if (!canConfigure(_this.app, doc)) return;
          _this.openNewAction(root);
          return;
        }
        var listed = event.target.closest('[data-open-field]');
        if (listed) {
          _this.openFieldInteraction(actionById(doc, listed.dataset.openField), root);
          return;
        }
        var placed = event.target.closest('[data-field-id]');
        if (placed) {
          _this.openFieldInteraction(actionById(doc, placed.dataset.fieldId), root);
          return;
        }
        if (event.target.closest('[data-page="prev"]')) {
          _this.cancelSignSequence();
          _this.page = Math.max(1, _this.page - 1);
          _this.pending_scroll = true;
          _this.update(root);
          return;
        }
        if (event.target.closest('[data-page="next"]')) {
          _this.cancelSignSequence();
          _this.page = Math.min(doc.document.page_count, _this.page + 1);
          _this.pending_scroll = true;
          _this.update(root);
          return;
        }
        var zoom = event.target.closest('[data-zoom]');
        if (zoom && !zoom.disabled) {
          _this.changeZoom(zoom.dataset.zoom === 'in' ? ZOOM_STEP : 1 / ZOOM_STEP, root);
          return;
        }
        if (event.target.closest('[data-reader-menu]')) {
          event.preventDefault();
          _this.reader_expanded = !_this.reader_expanded;
          root.querySelector('.reader').innerHTML = WorkspaceTemplate.reader(_this.view());
          _this.seatReader(root);
          return;
        }
        if (event.target.closest('[data-add-pdf]')) {
          event.preventDefault();
          _this.pickPdfToAppend();
          return;
        }
        if (event.target.closest('[data-close-document]')) {
          event.preventDefault();
          _this.cancelSignSequence();
          _this.openClosePrompt();
          return;
        }
        if (event.target.closest('[data-export]')) {
          if (doc.finalized) {
            _this.cancelSignSequence();
            _this.publish.openStatus();
            return;
          }
          var pending = (doc.actions || []).some(function (action) {
            return !doc.users[action.user];
          });
          if (!(doc.actions || []).length || pending) {
            _this.notice = pending ? 'Confirm who signs each box before finalizing.' : _this.notice;
            _this.update(root);
            return;
          }
          _this.notice = '';
          _this.publish.render();
        }
      });
      root.addEventListener('submit', function (event) {
        var _form$querySelector, _this$app$wallet;
        var form = event.target.closest('.add-signer');
        if (!form) {
          return;
        }
        event.preventDefault();
        var doc = _this.mod.document;
        if (!canConfigure(_this.app, doc)) return;
        var name = (_form$querySelector = form.querySelector('[data-signer-name]')) === null || _form$querySelector === void 0 ? void 0 : _form$querySelector.value.trim();
        if (!doc || !name) {
          return;
        }
        var decision = resolveSigner(doc, name);
        if (decision.action === 'existing') {
          if (decision.conflict) {
            duplicateSignerNotice();
          }
          _this.arrived = decision.index;
          _this.adding_signer = false;
          _this.update(root);
          return;
        }
        _this.arrived = addUser(doc, decision.name, (_this$app$wallet = _this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.publicKey);
        _this.adding_signer = false;
        _this.update(root);
      });
      root.addEventListener('change', function (event) {
        var page_input = event.target.closest('[data-page-input]');
        if (!page_input || !_this.mod.document) {
          return;
        }
        _this.cancelSignSequence();
        _this.page = clampPage(page_input.value, _this.mod.document.document.page_count, _this.page);
        _this.pending_scroll = true;
        _this.update(root);
      });
      var reader = root.querySelector('.reader');
      reader.addEventListener('pointerdown', function (event) {
        return _this.beginReaderDrag(event);
      });
      reader.addEventListener('pointermove', function (event) {
        return _this.moveReader(event, root);
      });
      reader.addEventListener('pointerup', function (event) {
        return _this.endReaderDrag(event);
      });
      reader.addEventListener('pointercancel', function (event) {
        return _this.endReaderDrag(event);
      });
      var sheet = root.querySelector('.sheet');
      sheet.addEventListener('pointerdown', function (event) {
        return _this.beginSelection(event, root);
      });
      sheet.addEventListener('pointermove', function (event) {
        return _this.moveSelection(event, root);
      });
      sheet.addEventListener('pointerup', function (event) {
        return _this.endSelection(event, root);
      });
      sheet.addEventListener('pointercancel', function (event) {
        return _this.endSelection(event, root);
      });
      root.querySelector('.sheet-wrap').addEventListener('scroll', function () {
        return _this.onScroll(root);
      }, {
        passive: true
      });
      root.querySelector('.sheet-wrap').addEventListener('wheel', function () {
        return _this.interruptSigning(root);
      }, {
        passive: true
      });
    }
  }, {
    key: "beginSelection",
    value: function beginSelection(event) {
      if (event.button !== 0) {
        return;
      }
      if (event.target.closest('[data-resize]')) {
        this.beginResize(event);
        return;
      }
      if (this.beginMove(event)) {
        return;
      }
      var doc = this.mod.document;
      var direct = Boolean(doc && !doc.finalized && canConfigure(this.app, doc));
      if (!this.placing && !direct) {
        return;
      }
      if (event.target.closest('[data-field-id]')) {
        return;
      }
      var stage = event.target.closest('.fields');
      var page = stage === null || stage === void 0 ? void 0 : stage.closest('.pdf-page');
      if (!stage || !page) {
        return;
      }
      var box = stage.getBoundingClientRect();
      if (!box.width || !box.height) {
        return;
      }
      this.drag = {
        pointer: event.pointerId,
        box: box,
        page: Number(page.dataset.page),
        stage: stage,
        x0: event.clientX,
        y0: event.clientY
      };
      this.draft = null;
      stage.setPointerCapture(event.pointerId);
    }
  }, {
    key: "moveSelection",
    value: function moveSelection(event, root) {
      if (this.resize && this.resize.pointer === event.pointerId) {
        this.applyResize(event);
        return;
      }
      if (this.move && this.move.pointer === event.pointerId) {
        this.applyMove(event);
        return;
      }
      if (!this.drag || this.drag.pointer !== event.pointerId) {
        return;
      }
      var rect = rectangle(this.drag, event.clientX, event.clientY);
      if (!rect) {
        return;
      }
      var intent = this.intent || {};
      this.draft = _objectSpread({
        page: this.drag.page,
        type: intent.type || 'signature',
        user: Number.isInteger(intent.user) ? intent.user : -1,
        pendingName: intent.newName || ''
      }, rect);
      paintDraft(this.drag.stage, this.draft);
    }
  }, {
    key: "endSelection",
    value: function endSelection(event, root) {
      var _this$app$wallet3;
      if (this.resize && this.resize.pointer === event.pointerId) {
        this.finishResize(event);
        return;
      }
      if (this.move && this.move.pointer === event.pointerId) {
        this.finishMove(event, root);
        return;
      }
      if (!this.drag || this.drag.pointer !== event.pointerId) {
        return;
      }
      var stage = this.drag.stage;
      var page = this.drag.page;
      var drag = this.drag;
      if (stage !== null && stage !== void 0 && stage.hasPointerCapture(event.pointerId)) {
        stage.releasePointerCapture(event.pointerId);
      }
      var rect = rectangle(drag, event.clientX, event.clientY);
      var direct = !this.placing;
      this.drag = null;
      if (direct) {
        var box = !rect || rect.pixels < MIN_DRAG ? defaultFieldBox(drag, drag.x0, drag.y0, this.field_type) : fitBox(rect);
        this.placeSignature(page, box, root);
        return;
      }
      if (!rect || rect.pixels < MIN_DRAG) {
        this.draft = null;
        this.update(root);
        return;
      }
      var doc = this.mod.document;
      var intent = this.intent;
      if (!canConfigure(this.app, doc)) {
        this.draft = null;
        this.placing = false;
        this.intent = null;
        this.update(root);
        return;
      }
      this.page = page;
      if (!doc || !intent) {
        this.placing = false;
        this.draft = null;
        this.intent = null;
        this.update(root);
        return;
      }
      var user = intent.user;
      if (intent.newName) {
        var decision = resolveSigner(doc, intent.email || intent.newName, intent.email ? intent.newName : undefined);
        if (decision.action === 'existing') {
          if (decision.conflict) {
            duplicateSignerNotice();
          }
          user = decision.index;
        } else {
          var _this$app$wallet2;
          user = addUser(doc, decision.name, (_this$app$wallet2 = this.app.wallet) === null || _this$app$wallet2 === void 0 ? void 0 : _this$app$wallet2.publicKey);
          if (intent.email && doc.users[user]) {
            doc.users[user].email = intent.email;
          }
        }
        this.arrived = user;
      }
      if (!doc.users[user]) {
        this.draft = null;
        this.update(root);
        return;
      }
      placeConfiguredAction(doc, {
        type: intent.type,
        user: user,
        page: page,
        x: rect.x,
        y: rect.y,
        width: rect.width,
        height: rect.height,
        everyPage: intent.everyPage === true
      }, (_this$app$wallet3 = this.app.wallet) === null || _this$app$wallet3 === void 0 ? void 0 : _this$app$wallet3.publicKey);
      this.intent = null;
      this.placing = false;
      this.draft = null;
      this.update(root);
    }
  }, {
    key: "placeSignature",
    value: function placeSignature(page, box, root) {
      var _this2 = this;
      var doc = this.mod.document;
      this.draft = null;
      this.placing = false;
      if (!doc || doc.finalized || !canConfigure(this.app, doc) || !box) {
        this.update(root);
        return;
      }
      this.page = page;
      this.intent = null;
      this.focus_field = null;
      this.draft = {
        page: page,
        type: this.field_type || '',
        user: doc.users.length ? 0 : -1,
        x: box.x,
        y: box.y,
        width: box.width,
        height: box.height
      };
      this.suppress_click = true;
      setTimeout(function () {
        _this2.suppress_click = false;
      }, 0);
      this.update(root);
      this.openField(root);
    }
  }, {
    key: "beginMove",
    value: function beginMove(event) {
      var fieldEl = event.target.closest('[data-field-id]');
      var stage = fieldEl === null || fieldEl === void 0 ? void 0 : fieldEl.closest('.fields');
      var doc = this.mod.document;
      var action = fieldEl ? actionById(doc, fieldEl.dataset.fieldId) : null;
      if (!fieldEl || !stage || !action || !canConfigure(this.app, doc)) {
        return false;
      }
      var box = stage.getBoundingClientRect();
      if (!box.width || !box.height) {
        return false;
      }
      var point = pointerFraction(box, event.clientX, event.clientY);
      this.move = {
        pointer: event.pointerId,
        stage: stage,
        fieldEl: fieldEl,
        action: action,
        x: action.x,
        y: action.y,
        width: action.width,
        height: action.height,
        offsetX: point.x - action.x,
        offsetY: point.y - action.y,
        x0: event.clientX,
        y0: event.clientY,
        next: null,
        moved: false
      };
      stage.classList.add('dragging');
      fieldEl.classList.add('moving');
      stage.setPointerCapture(event.pointerId);
      return true;
    }
  }, {
    key: "applyMove",
    value: function applyMove(event) {
      var move = this.move;
      var box = move.stage.getBoundingClientRect();
      if (!box.width || !box.height) {
        return;
      }
      var point = pointerFraction(box, event.clientX, event.clientY);
      var next = placeBox(move, point.x - move.offsetX, point.y - move.offsetY);
      move.next = next;
      move.moved = move.moved || Math.hypot(event.clientX - move.x0, event.clientY - move.y0) >= MIN_DRAG;
      move.fieldEl.style.left = "".concat((next.x * 100).toFixed(2), "%");
      move.fieldEl.style.top = "".concat((next.y * 100).toFixed(2), "%");
    }
  }, {
    key: "finishMove",
    value: function finishMove(event, root) {
      var _move$stage,
        _this3 = this;
      var move = this.move;
      if ((_move$stage = move.stage) !== null && _move$stage !== void 0 && _move$stage.hasPointerCapture(event.pointerId)) {
        move.stage.releasePointerCapture(event.pointerId);
      }
      move.stage.classList.remove('dragging');
      move.fieldEl.classList.remove('moving');
      var traveled = Math.hypot(event.clientX - move.x0, event.clientY - move.y0) >= MIN_DRAG;
      var next = move.moved || traveled ? move.next : null;
      var doc = this.mod.document;
      var repositioned = Boolean(next && canConfigure(this.app, doc) && (move.action.x !== next.x || move.action.y !== next.y));
      if (repositioned) {
        syncGroupGeometry(doc, move.action, {
          x: next.x,
          y: next.y,
          width: move.action.width,
          height: move.action.height
        });
        stripSignatures(doc);
        doc.edited = true;
        if (this.draft && Number(this.draft.id) === Number(move.action.id)) {
          this.draft.x = next.x;
          this.draft.y = next.y;
        }
      } else {
        move.fieldEl.style.left = "".concat((move.x * 100).toFixed(2), "%");
        move.fieldEl.style.top = "".concat((move.y * 100).toFixed(2), "%");
      }
      var action = move.action;
      this.move = null;
      if (repositioned || next) {
        this.suppress_click = true;
        setTimeout(function () {
          _this3.suppress_click = false;
        }, 0);
        if (repositioned) {
          this.update(root);
        }
        return;
      }
      this.suppress_click = true;
      setTimeout(function () {
        _this3.suppress_click = false;
      }, 0);
      this.openFieldInteraction(action, root);
    }
  }, {
    key: "beginResize",
    value: function beginResize(event) {
      var handle = event.target.closest('[data-resize]');
      var fieldEl = handle === null || handle === void 0 ? void 0 : handle.closest('[data-field-id]');
      var stage = handle === null || handle === void 0 ? void 0 : handle.closest('.fields');
      var doc = this.mod.document;
      var action = fieldEl ? actionById(doc, fieldEl.dataset.fieldId) : null;
      if (!handle || !stage || !action || !canConfigure(this.app, doc)) {
        return;
      }
      var box = stage.getBoundingClientRect();
      if (!box.width || !box.height) {
        return;
      }
      this.resize = {
        pointer: event.pointerId,
        edge: handle.dataset.resize,
        box: box,
        stage: stage,
        action: action,
        x: action.x,
        y: action.y,
        width: action.width,
        height: action.height,
        next: null
      };
      stage.setPointerCapture(event.pointerId);
      event.preventDefault();
    }
  }, {
    key: "applyResize",
    value: function applyResize(event) {
      var resize = this.resize;
      var point = pointerFraction(resize.box, event.clientX, event.clientY);
      var next = resizeBox(resize, resize.edge, point.x, point.y);
      resize.next = next;
      var el = resize.stage.querySelector("[data-field-id=\"".concat(CSS.escape(String(resize.action.id)), "\"]"));
      if (!el) {
        return;
      }
      el.style.left = "".concat((next.x * 100).toFixed(2), "%");
      el.style.top = "".concat((next.y * 100).toFixed(2), "%");
      el.style.width = "".concat((next.width * 100).toFixed(2), "%");
      el.style.height = "".concat((next.height * 100).toFixed(2), "%");
    }
  }, {
    key: "finishResize",
    value: function finishResize(event) {
      var _resize$stage,
        _this4 = this;
      var resize = this.resize;
      if ((_resize$stage = resize.stage) !== null && _resize$stage !== void 0 && _resize$stage.hasPointerCapture(event.pointerId)) {
        resize.stage.releasePointerCapture(event.pointerId);
      }
      var next = resize.next;
      var doc = this.mod.document;
      if (next && canConfigure(this.app, doc)) {
        var action = resize.action;
        var changed = action.x !== next.x || action.y !== next.y || action.width !== next.width || action.height !== next.height;
        if (changed) {
          syncGroupGeometry(doc, action, next);
          stripSignatures(doc);
          doc.edited = true;
          if (this.draft && Number(this.draft.id) === Number(action.id)) {
            this.draft.x = next.x;
            this.draft.y = next.y;
            this.draft.width = next.width;
            this.draft.height = next.height;
          }
          var root = document.querySelector('.saito-container > .workspace');
          if (root) {
            this.update(root);
          }
        }
      }
      this.resize = null;
      var moved = Boolean(next);
      if (moved) {
        this.suppress_click = true;
        setTimeout(function () {
          _this4.suppress_click = false;
        }, 0);
      }
    }
  }, {
    key: "openClosePrompt",
    value: function openClosePrompt() {
      var _this5 = this;
      if (this.close_prompt) {
        return;
      }
      var prompt = new ClosePrompt(this.app, this.mod);
      this.close_prompt = prompt;
      prompt.render({
        onDismiss: function onDismiss() {
          if (_this5.close_prompt === prompt) {
            _this5.close_prompt = null;
          }
        },
        onLeave: function onLeave() {
          return _this5.leaveDocument();
        },
        onExport: function onExport() {
          return _this5.exportWorkingCopy();
        }
      });
    }
  }, {
    key: "pickPdfToAppend",
    value: function pickPdfToAppend() {
      var _this6 = this;
      var doc = this.mod.document;
      if (!doc || doc.finalized) {
        return;
      }
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = 'application/pdf,.pdf';
      input.style.display = 'none';
      input.onchange = function () {
        var file = input.files && input.files[0];
        if (file) {
          _this6.appendPdf(file);
        }
      };
      input.click();
    }
  }, {
    key: "appendPdf",
    value: function () {
      var _appendPdf = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
        var doc, root, added, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              doc = this.mod.document;
              root = document.querySelector('.saito-container > .workspace');
              if (!(!doc || doc.finalized)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (isPdf(file)) {
                _context.n = 2;
                break;
              }
              this.notice = 'Choose a PDF or a SaitoSign transaction.';
              if (root) {
                this.update(root);
              }
              return _context.a(2);
            case 2:
              _context.p = 2;
              _context.n = 3;
              return openPdfs([file]);
            case 3:
              added = _context.v;
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.notice = 'That PDF could not be read.';
              if (root) {
                this.update(root);
              }
              return _context.a(2);
            case 5:
              doc.document.pdf = pdfEntries(doc).concat(pdfEntries(added));
              doc.document.page_count = pdfEntries(doc).reduce(function (total, entry) {
                return total + (Number(entry.page_count) || 0);
              }, 0);
              doc.edited = true;
              stripSignatures(doc);
              if (!doc.creator) {
                _context.n = 6;
                break;
              }
              _context.n = 6;
              return createCreatorProof(this.app, doc, doc.creator);
            case 6:
              this.notice = '';
              this.render();
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4]]);
      }));
      function appendPdf(_x) {
        return _appendPdf.apply(this, arguments);
      }
      return appendPdf;
    }()
  }, {
    key: "exportWorkingCopy",
    value: function () {
      var _exportWorkingCopy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this$mod$document;
        var before, finalized, saved;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              before = this.mod.document;
              finalized = (before === null || before === void 0 ? void 0 : before.finalized) === true;
              _context2.n = 1;
              return this.mod.exportDocument({
                draft: true
              });
            case 1:
              saved = _context2.v;
              if (!(this.mod.document !== before || ((_this$mod$document = this.mod.document) === null || _this$mod$document === void 0 ? void 0 : _this$mod$document.finalized) !== finalized)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, false);
            case 2:
              return _context2.a(2, saved === true);
          }
        }, _callee2, this);
      }));
      function exportWorkingCopy() {
        return _exportWorkingCopy.apply(this, arguments);
      }
      return exportWorkingCopy;
    }()
  }, {
    key: "leaveDocument",
    value: function leaveDocument() {
      this.cancelSignSequence();
      if (this.overlay && this.overlay.close) {
        this.overlay.close();
        this.overlay = null;
      }
      if (this.sign_overlay) {
        this.sign_closing = true;
        this.sign_overlay.close();
        this.sign_closing = false;
        this.sign_overlay = null;
      }
      if (this.publish && this.publish.close) {
        this.publish.close();
      }
      this.focus_field = null;
      revoke(this.mod.document);
      this.mod.document = emptyDocument();
      this.close_prompt = null;
      this.mod.main.showSplash();
    }
  }, {
    key: "openSigner",
    value: function openSigner(index) {
      var _this7 = this;
      var user = this.mod.document.users[index];
      if (!user) {
        return;
      }
      var overlay = new SignerOverlay(this.app, this.mod);
      this.overlay = overlay;
      var identity = userIdentity(user);
      overlay.render({
        name: identity.name,
        email: identity.email,
        publickey: user.publickey || '',
        verified: verifiedMethods(this.app, user).length > 0,
        signed: user.signed === true,
        editable: canConfigure(this.app, this.mod.document)
      }, {
        onUpdate: function onUpdate(fields) {
          return _this7.saveUser(index, fields);
        },
        onRemove: function onRemove() {
          var _this7$app$wallet;
          if (!canConfigure(_this7.app, _this7.mod.document)) return;
          removeUser(_this7.mod.document, index, (_this7$app$wallet = _this7.app.wallet) === null || _this7$app$wallet === void 0 ? void 0 : _this7$app$wallet.publicKey);
          overlay.close();
        },
        onClose: function onClose() {
          if (_this7.overlay === overlay) {
            _this7.overlay = null;
          }
          var current = document.querySelector('.saito-container > .workspace');
          if (current) {
            _this7.update(current);
          }
        }
      });
    }
  }, {
    key: "saveUser",
    value: function saveUser(index, fields) {
      var doc = this.mod.document;
      if (!canConfigure(this.app, doc)) return;
      var user = doc.users[index];
      if (!fields || !user) {
        return;
      }
      var nextEmail = String(fields.email || '').trim();
      if (nextEmail && nextEmail !== String(user.email || '').trim()) {
        var decision = resolveSigner(doc, nextEmail, fields.name || user.name, index);
        if (decision.action === 'existing') {
          if (decision.conflict) {
            duplicateSignerNotice();
          }
          return;
        }
      }
      if (fields.name) {
        var _this$app$wallet4;
        renameUser(doc, index, fields.name, (_this$app$wallet4 = this.app.wallet) === null || _this$app$wallet4 === void 0 ? void 0 : _this$app$wallet4.publicKey);
      }
      if ((user.email || '') !== fields.email) {
        user.email = fields.email;
        doc.edited = true;
      }
      this.overlay.close();
    }
  }, {
    key: "openNewAction",
    value: function openNewAction(root) {
      var doc = this.mod.document;
      if (!canConfigure(this.app, doc)) {
        return;
      }
      this.placing = false;
      this.focus_field = null;
      this.draft = null;
      this.intent = null;
      var current = document.querySelector('.saito-container > .workspace') || root;
      if (current) {
        this.update(current);
      }
      this.openField(root);
    }
  }, {
    key: "openFieldInteraction",
    value: function openFieldInteraction(field, root) {
      var _this8 = this;
      var doc = this.mod.document;
      if (!field || !doc) {
        return;
      }
      if (!doc.finalized) {
        this.openExisting(field, root);
        return;
      }
      if (field.type !== 'signature' && field.type !== 'initial') {
        this.openExisting(field, root);
        return;
      }
      var user = doc.users[field.user];
      var relation = signerRelation(this.app, user, doc);
      if (relation.recognized && relation.verified) {
        this.openSignPrompt(field);
        return;
      }
      if (relation.recognized) {
        this.publish.beginVerification(field.user, field.id);
        return;
      }
      if (relation.bound && !relation.recognized) {
        this.openExisting(field, root);
        return;
      }
      var prompt = new IdentityPrompt(this.app, this.mod);
      var name = (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.email) || '';
      prompt.render(name, {
        onYes: function onYes() {
          return _this8.publish.beginVerification(field.user, field.id);
        }
      });
    }
  }, {
    key: "continueSigning",
    value: function continueSigning(actionId) {
      var doc = this.mod.document;
      var action = actionById(doc, actionId);
      var user = action ? doc.users[action.user] : null;
      if (!(doc !== null && doc !== void 0 && doc.finalized) || !action || !user) {
        return;
      }
      if (!verificationSatisfied(this.app, doc, user)) {
        this.publish.beginVerification(action.user, action.id);
        return;
      }
      if (!canSignAction(this.app, action, user, doc)) {
        return;
      }
      this.openSignPrompt(action);
    }
  }, {
    key: "openSignPrompt",
    value: function openSignPrompt(field) {
      var _this9 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var doc = this.mod.document;
      var root = document.querySelector('.saito-container > .workspace');
      if (!options.sequence) {
        this.cancelSignSequence();
      }
      if (!(doc !== null && doc !== void 0 && doc.finalized) || !field || !root) {
        return;
      }
      var start = canSignAction(this.app, field, doc.users[field.user], doc) ? field : nextUnsignedAction(this.app, doc, field.user, field);
      if (!start) {
        this.publish.openStatus('You have added your signature everywhere required on the document.');
        return;
      }
      var user = doc.users[start.user];
      if (!verificationSatisfied(this.app, doc, user)) {
        this.publish.beginVerification(start.user, start.id);
        return;
      }
      this.focus_field = start.id;
      this.page = start.page;
      if (!options.sequence) {
        this.pending_scroll = true;
        this.scroll_field = start.id;
      }
      this.update(root);
      this.dismissSignOverlay();
      var overlay = new SignOverlay(this.app, this.mod);
      this.sign_overlay = overlay;
      overlay.render({
        name: (user === null || user === void 0 ? void 0 : user.name) || '',
        email: (user === null || user === void 0 ? void 0 : user.email) || ''
      }, {
        onSign: function onSign() {
          return _this9.signThenAdvance(start);
        },
        onClose: function onClose() {
          if (_this9.sign_closing) {
            return;
          }
          if (_this9.sign_overlay === overlay) {
            _this9.sign_overlay = null;
          }
          _this9.cancelSignSequence();
          if (Number(_this9.focus_field) === Number(start.id)) {
            _this9.focus_field = null;
          }
          var current = document.querySelector('.saito-container > .workspace');
          if (current) {
            _this9.update(current);
          }
        }
      });
    }
  }, {
    key: "signThenAdvance",
    value: function () {
      var _signThenAdvance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(action) {
        var token, signed, root, next, current;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!this.sign_lock) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, false);
            case 1:
              this.sign_lock = true;
              this.cancelSignSequence();
              token = this.sign_step;
              _context3.p = 2;
              _context3.n = 3;
              return this.signAction(action);
            case 3:
              signed = _context3.v;
              root = document.querySelector('.saito-container > .workspace');
              if (signed) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2, false);
            case 4:
              if (!(this.sign_step !== token)) {
                _context3.n = 5;
                break;
              }
              if (root) {
                this.update(root);
              }
              return _context3.a(2, true);
            case 5:
              next = nextUnsignedAction(this.app, this.mod.document, action.user, action);
              this.dismissSignOverlay();
              this.focus_field = null;
              this.confirming_field = action.id;
              if (root) {
                this.update(root);
              }
              _context3.n = 6;
              return this.waitForSignStep(SIGN_CONFIRM_MS);
            case 6:
              if (!(this.sign_step !== token)) {
                _context3.n = 7;
                break;
              }
              return _context3.a(2, true);
            case 7:
              this.confirming_field = null;
              current = document.querySelector('.saito-container > .workspace');
              if (next) {
                _context3.n = 8;
                break;
              }
              this.focus_field = null;
              if (current) {
                this.update(current);
              }
              this.publish.openStatus('You have added your signature everywhere required on the document.');
              return _context3.a(2, true);
            case 8:
              this.focus_field = next.id;
              this.page = next.page;
              if (!current) {
                _context3.n = 9;
                break;
              }
              this.update(current);
              _context3.n = 9;
              return this.scrollToField(current, next.id, {
                smooth: true,
                preferTop: true
              });
            case 9:
              if (!(this.sign_step !== token || !document.querySelector('.saito-container > .workspace'))) {
                _context3.n = 10;
                break;
              }
              return _context3.a(2, true);
            case 10:
              this.openSignPrompt(next, {
                sequence: true
              });
              return _context3.a(2, true);
            case 11:
              _context3.p = 11;
              this.sign_lock = false;
              return _context3.f(11);
            case 12:
              return _context3.a(2);
          }
        }, _callee3, this, [[2,, 11, 12]]);
      }));
      function signThenAdvance(_x2) {
        return _signThenAdvance.apply(this, arguments);
      }
      return signThenAdvance;
    }()
  }, {
    key: "dismissSignOverlay",
    value: function dismissSignOverlay() {
      if (!this.sign_overlay) {
        return;
      }
      this.sign_closing = true;
      this.sign_overlay.close();
      this.sign_closing = false;
      this.sign_overlay = null;
    }
  }, {
    key: "cancelSignSequence",
    value: function cancelSignSequence() {
      this.sign_step = (this.sign_step || 0) + 1;
      this.confirming_field = null;
      if (this.sign_wait) {
        var finish = this.sign_wait;
        this.sign_wait = null;
        finish();
      } else if (this.sign_timer) {
        clearTimeout(this.sign_timer);
        this.sign_timer = null;
      }
      if (this.sign_scroll_wait) {
        var finishScroll = this.sign_scroll_wait;
        this.sign_scroll_wait = null;
        finishScroll();
      }
      if (typeof document === 'undefined') {
        return;
      }
      var wrap = document.querySelector('.saito-container > .workspace .sheet-wrap');
      if (wrap !== null && wrap !== void 0 && wrap.scrollTo) {
        wrap.scrollTo({
          top: wrap.scrollTop,
          left: wrap.scrollLeft,
          behavior: 'auto'
        });
      }
    }
  }, {
    key: "interruptSigning",
    value: function interruptSigning(root) {
      if (!this.sign_timer && this.confirming_field == null && !this.sign_lock && !this.sign_scroll_wait) {
        return;
      }
      this.cancelSignSequence();
      if (root) {
        this.update(root);
      }
    }
  }, {
    key: "waitForSignStep",
    value: function waitForSignStep(ms) {
      var _this0 = this;
      return new Promise(function (resolve) {
        var _finish = function finish() {
          if (_this0.sign_timer) {
            clearTimeout(_this0.sign_timer);
            _this0.sign_timer = null;
          }
          if (_this0.sign_wait === _finish) {
            _this0.sign_wait = null;
          }
          resolve();
        };
        _this0.sign_wait = _finish;
        _this0.sign_timer = setTimeout(_finish, ms);
      });
    }
  }, {
    key: "signAction",
    value: function () {
      var _signAction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(action) {
        var _doc$users;
        var doc, user, privateKey, signed, kept;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              doc = this.mod.document;
              user = action ? doc === null || doc === void 0 || (_doc$users = doc.users) === null || _doc$users === void 0 ? void 0 : _doc$users[action.user] : null;
              if (!(!(doc !== null && doc !== void 0 && doc.finalized) || !action || !user || !canSignAction(this.app, action, user, doc))) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, false);
            case 1:
              if (commitmentIntact(this.app, doc)) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2, false);
            case 2:
              _context4.n = 3;
              return this.app.wallet.getPrivateKey();
            case 3:
              privateKey = _context4.v;
              signed = action.type === 'initial' ? addInitial(this.app, action, privateKey, doc.hash) : addSignature(this.app, action, privateKey, doc.hash);
              if (signed !== null && signed !== void 0 && signed.signature) {
                _context4.n = 4;
                break;
              }
              return _context4.a(2, false);
            case 4:
              kept = (Array.isArray(user.signatures) ? user.signatures : []).filter(function (entry) {
                return Number(entry === null || entry === void 0 ? void 0 : entry.id) !== Number(action.id);
              });
              kept.push(signed);
              user.signatures = kept;
              doc.edited = true;
              return _context4.a(2, verifyActionSignature(this.app, action, user, doc));
          }
        }, _callee4, this);
      }));
      function signAction(_x3) {
        return _signAction.apply(this, arguments);
      }
      return signAction;
    }()
  }, {
    key: "openExisting",
    value: function openExisting(field, root) {
      var _this$mod$document2;
      this.cancelSignSequence();
      if (!field || !canConfigure(this.app, this.mod.document) && !((_this$mod$document2 = this.mod.document) !== null && _this$mod$document2 !== void 0 && _this$mod$document2.finalized)) {
        return;
      }
      this.placing = false;
      this.intent = null;
      this.focus_field = field.id;
      this.page = field.page;
      this.pending_scroll = true;
      this.scroll_field = field.id;
      this.draft = {
        id: field.id,
        page: field.page,
        type: field.type,
        user: field.user,
        x: field.x,
        y: field.y,
        width: field.width,
        height: field.height
      };
      this.update(root);
      this.openField(root);
    }
  }, {
    key: "openField",
    value: function openField(root) {
      var _this1 = this;
      if (this.overlay) {
        this.replacing = true;
        this.overlay.close();
        this.replacing = false;
      }
      var overlay = new FieldOverlay(this.app, this.mod);
      this.overlay = overlay;
      overlay.render(this.fieldView(), {
        onPreview: function onPreview(form) {
          return _this1.previewField(form);
        },
        onRemove: function onRemove() {
          var _this1$app$wallet;
          if (!canConfigure(_this1.app, _this1.mod.document)) return;
          removeAction(_this1.mod.document, _this1.draft.id, (_this1$app$wallet = _this1.app.wallet) === null || _this1$app$wallet === void 0 ? void 0 : _this1$app$wallet.publicKey);
          overlay.close();
        },
        onSave: function onSave(form) {
          if (_this1.draft) {
            return _this1.saveField(form);
          }
          return _this1.armPlacement(form);
        },
        onSign: function onSign() {
          return _this1.signField();
        },
        onClose: function onClose() {
          var _this1$draft;
          if (_this1.replacing) {
            return;
          }
          var started = _this1.arming;
          _this1.arming = false;
          if (!started) {
            _this1.intent = null;
            _this1.placing = false;
          }
          if (((_this1$draft = _this1.draft) === null || _this1$draft === void 0 ? void 0 : _this1$draft.id) != null && Number(_this1.focus_field) === Number(_this1.draft.id)) {
            _this1.focus_field = null;
          }
          _this1.draft = null;
          if (_this1.overlay === overlay) {
            _this1.overlay = null;
          }
          var current = document.querySelector('.saito-container > .workspace');
          if (current) {
            _this1.update(current);
          }
        }
      });
    }
  }, {
    key: "armPlacement",
    value: function armPlacement(form) {
      var _form$querySelector2, _form$querySelector3;
      var doc = this.mod.document;
      if (!canConfigure(this.app, doc)) {
        return false;
      }
      var type = (_form$querySelector2 = form.querySelector('[data-field-type]')) === null || _form$querySelector2 === void 0 ? void 0 : _form$querySelector2.value;
      var chosen = (_form$querySelector3 = form.querySelector('[data-field-signer]')) === null || _form$querySelector3 === void 0 ? void 0 : _form$querySelector3.value;
      if (!ACTION_TYPES[type]) {
        return false;
      }
      var everyPage = everyPageChecked(form, type);
      if (chosen === 'new') {
        var _form$querySelector4, _form$querySelector5;
        var name = ((_form$querySelector4 = form.querySelector('[data-signer-name]')) === null || _form$querySelector4 === void 0 ? void 0 : _form$querySelector4.value.trim()) || '';
        var email = ((_form$querySelector5 = form.querySelector('[data-signer-email]')) === null || _form$querySelector5 === void 0 ? void 0 : _form$querySelector5.value.trim()) || '';
        if (!name || !isEmailAddress(email)) {
          return false;
        }
        var decision = resolveSigner(doc, email, name);
        if (decision.action === 'existing') {
          var select = form.querySelector('[data-field-signer]');
          if (select) {
            select.value = String(decision.index);
          }
          var extra = form.querySelector('.new-signer');
          if (extra) {
            extra.hidden = true;
          }
          if (decision.conflict) {
            duplicateSignerNotice();
            return false;
          }
          this.intent = {
            type: type,
            user: decision.index,
            newName: '',
            everyPage: everyPage
          };
        } else {
          this.intent = {
            type: type,
            user: null,
            newName: decision.name,
            email: email,
            everyPage: everyPage
          };
        }
      } else {
        var user = Number(chosen);
        if (!doc.users[user]) {
          return false;
        }
        this.intent = {
          type: type,
          user: user,
          newName: '',
          everyPage: everyPage
        };
      }
      this.field_type = type;
      this.placing = true;
      this.draft = null;
      this.focus_field = null;
      this.arming = true;
      this.overlay.close();
      return true;
    }
  }, {
    key: "saveField",
    value: function saveField(form) {
      var doc = this.mod.document;
      var draft = this.draft;
      if (!canConfigure(this.app, doc) || !draft) {
        return false;
      }
      var type = form.querySelector('[data-field-type]').value;
      var chosen = form.querySelector('[data-field-signer]').value;
      if (!ACTION_TYPES[type]) {
        return false;
      }
      var userIndex = Number(chosen);
      if (chosen === 'new') {
        var _form$querySelector6, _form$querySelector7;
        var name = ((_form$querySelector6 = form.querySelector('[data-signer-name]')) === null || _form$querySelector6 === void 0 ? void 0 : _form$querySelector6.value.trim()) || '';
        var email = ((_form$querySelector7 = form.querySelector('[data-signer-email]')) === null || _form$querySelector7 === void 0 ? void 0 : _form$querySelector7.value.trim()) || '';
        if (!name || !isEmailAddress(email)) {
          return false;
        }
        var decision = resolveSigner(doc, email, name);
        if (decision.action === 'existing') {
          if (decision.conflict) {
            duplicateSignerNotice();
            return false;
          }
          userIndex = decision.index;
        } else if (decision.action === 'create') {
          var _this$app$wallet5;
          userIndex = addUser(doc, decision.name, (_this$app$wallet5 = this.app.wallet) === null || _this$app$wallet5 === void 0 ? void 0 : _this$app$wallet5.publicKey);
          if (!doc.users[userIndex]) {
            return false;
          }
          doc.users[userIndex].email = email;
          this.arrived = userIndex;
        } else {
          return false;
        }
      }
      var user = doc.users[userIndex];
      if (!user) {
        return false;
      }
      if (draft.id) {
        var action = actionById(doc, draft.id);
        if (action && (action.type !== type || action.user !== userIndex)) {
          syncGroupFields(doc, action, {
            type: type,
            user: userIndex
          });
          stripSignatures(doc);
          doc.edited = true;
        }
      } else {
        var _this$app$wallet6;
        var box = geometryForNewField(type, draft);
        var placed = placeConfiguredAction(doc, {
          type: type,
          user: userIndex,
          page: draft.page,
          x: box.x,
          y: box.y,
          width: box.width,
          height: box.height,
          everyPage: everyPageChecked(form, type)
        }, (_this$app$wallet6 = this.app.wallet) === null || _this$app$wallet6 === void 0 ? void 0 : _this$app$wallet6.publicKey);
        if (!placed) {
          return false;
        }
      }
      this.field_type = type;
      this.notice = '';
      this.overlay.close();
      return true;
    }
  }, {
    key: "previewField",
    value: function previewField(form) {
      var _form$querySelector8, _form$querySelector9, _doc$users$index;
      var draft = this.draft;
      var doc = this.mod.document;
      if (!draft || !doc) {
        return;
      }
      var chosen = (_form$querySelector8 = form.querySelector('[data-field-signer]')) === null || _form$querySelector8 === void 0 ? void 0 : _form$querySelector8.value;
      var type = ((_form$querySelector9 = form.querySelector('[data-field-type]')) === null || _form$querySelector9 === void 0 ? void 0 : _form$querySelector9.value) || 'signature';
      var index = chosen === 'new' ? doc.users.length : Number(chosen);
      var el = draft.id ? document.querySelector(".workspace .field[data-field-id=\"".concat(CSS.escape(String(draft.id)), "\"]")) : document.querySelector('.workspace .field.draft');
      if (!el) {
        return;
      }
      var color = signerColor(index);
      el.style.background = color;
      el.style.borderColor = color;
      var name = chosen === 'new' ? '' : ((_doc$users$index = doc.users[index]) === null || _doc$users$index === void 0 ? void 0 : _doc$users$index.name) || '';
      var text = el.querySelector('.text');
      if (text) {
        text.textContent = name ? "".concat(typeLabel(type), " - ").concat(name) : typeLabel(type);
      }
    }
  }, {
    key: "signField",
    value: function () {
      var _signField = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _form$querySelector0;
        var doc, draft, action, user, form, type, privateKey, signed, kept;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              doc = this.mod.document;
              draft = this.draft;
              if (!(!(doc !== null && doc !== void 0 && doc.finalized) || !(draft !== null && draft !== void 0 && draft.id))) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, false);
            case 1:
              action = actionById(doc, draft.id);
              user = action ? doc.users[action.user] : null;
              if (!(!action || !user || !canSignAction(this.app, action, user, doc))) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, false);
            case 2:
              form = document.querySelector('.saitosign-field');
              type = form === null || form === void 0 || (_form$querySelector0 = form.querySelector('[data-field-type]')) === null || _form$querySelector0 === void 0 ? void 0 : _form$querySelector0.value;
              if (!(doc.finalized && type !== action.type)) {
                _context5.n = 3;
                break;
              }
              return _context5.a(2, false);
            case 3:
              if (!doc.finalized && (type === 'signature' || type === 'initial')) {
                action.type = type;
              }
              if (commitmentIntact(this.app, doc)) {
                _context5.n = 4;
                break;
              }
              return _context5.a(2, false);
            case 4:
              _context5.n = 5;
              return this.app.wallet.getPrivateKey();
            case 5:
              privateKey = _context5.v;
              signed = action.type === 'initial' ? addInitial(this.app, action, privateKey, doc.hash) : addSignature(this.app, action, privateKey, doc.hash);
              if (signed !== null && signed !== void 0 && signed.signature) {
                _context5.n = 6;
                break;
              }
              return _context5.a(2, false);
            case 6:
              kept = (Array.isArray(user.signatures) ? user.signatures : []).filter(function (entry) {
                return Number(entry === null || entry === void 0 ? void 0 : entry.id) !== Number(action.id);
              });
              kept.push(signed);
              user.signatures = kept;
              doc.edited = true;
              this.overlay.close();
              return _context5.a(2, true);
          }
        }, _callee5, this);
      }));
      function signField() {
        return _signField.apply(this, arguments);
      }
      return signField;
    }()
  }, {
    key: "fieldView",
    value: function fieldView() {
      var doc = this.mod.document;
      var draft = this.draft;
      var intent = this.intent;
      var existing = Boolean(draft === null || draft === void 0 ? void 0 : draft.id);
      var pending = Boolean(draft && !draft.id);
      var type = '';
      var signer_index = doc.users.length ? 0 : null;
      var new_name = '';
      var new_email = '';
      var choose_new = doc.users.length === 0;
      if (pending) {
        type = draft.type || this.field_type || '';
        var known = Number.isInteger(draft.user) && draft.user >= 0 && Boolean(doc.users[draft.user]);
        if (known) {
          signer_index = draft.user;
          choose_new = false;
        } else if (doc.users.length) {
          signer_index = 0;
          choose_new = false;
        } else {
          signer_index = null;
          choose_new = true;
        }
        new_name = draft.pendingName || '';
      } else if (existing) {
        type = draft.type || 'signature';
        var _known = Number.isInteger(draft.user) && Boolean(doc.users[draft.user]);
        signer_index = _known ? draft.user : null;
        choose_new = !_known;
      } else if (intent) {
        type = intent.type || this.field_type || '';
        new_name = intent.newName || '';
        new_email = intent.email || '';
        if (new_name) {
          choose_new = true;
          signer_index = null;
        } else if (Number.isInteger(intent.user) && doc.users[intent.user]) {
          signer_index = intent.user;
          choose_new = false;
        }
      } else {
        type = this.field_type || '';
      }
      var signer = existing ? doc.users[signer_index] : null;
      var action = existing ? actionById(doc, draft.id) : null;
      var can_sign = Boolean(doc.finalized && action && signer && canSignAction(this.app, action, signer, doc));
      var signer_ready = !choose_new && signer_index != null && Boolean(doc.users[signer_index]);
      return {
        existing: existing,
        editable: canConfigure(this.app, doc),
        defer_signer: !existing,
        type: type,
        signer_index: signer_index,
        choose_new: choose_new,
        new_name: new_name,
        new_email: new_email,
        signer_ready: signer_ready,
        allow_every_page: !existing,
        every_page: false,
        can_sign: can_sign,
        already_signed: Boolean(action && signer && verifyActionSignature(this.app, action, signer, doc)),
        sign_index: can_sign ? signer_index : null,
        signers: doc.users.map(function (user, index) {
          return {
            index: index,
            name: user.name
          };
        })
      };
    }
  }, {
    key: "view",
    value: function view() {
      var _this10 = this;
      var doc = this.mod.document;
      if (this.page > doc.document.page_count) {
        this.page = doc.document.page_count;
      }
      if (this.page < 1) {
        this.page = 1;
      }
      var focus = this.focus_field;
      var confirming = this.confirming_field;
      var selected = function selected(id) {
        return focus != null && Number(id) === Number(focus);
      };
      var marked = function marked(id) {
        return confirming != null && Number(id) === Number(confirming);
      };
      // Pending placements stay off the page until Confirm; drag-to-place paints
      // temporary marks directly while the pointer is down.
      var draft = null;
      return {
        file_name: doc.document.name || 'Document',
        can_edit: canConfigure(this.app, doc),
        finalized: doc.finalized === true,
        verified: documentFullyVerified(this.app, doc),
        page: this.page,
        page_count: doc.document.page_count,
        notice: this.notice || '',
        placing: this.placing,
        adding_signer: this.adding_signer,
        edited: doc.edited,
        zoom: this.zoom,
        zoom_min: this.zoom_floor || ZOOM_MIN,
        zoom_max: ZOOM_MAX,
        reader_x: this.reader_x,
        reader_y: this.reader_y,
        reader_expanded: this.reader_expanded === true,
        signers: doc.users.map(function (user, index) {
          var mine = (doc.actions || []).filter(function (action) {
            return action.user === index && (action.type === 'signature' || action.type === 'initial');
          });
          var complete = mine.length > 0 && mine.every(function (action) {
            return verifyActionSignature(_this10.app, action, user, doc);
          });
          return {
            index: index,
            name: user.name,
            arrived: index === _this10.arrived,
            complete: complete
          };
        }),
        field_list: doc.actions.map(function (action) {
          var _doc$users$action$use;
          var name = ((_doc$users$action$use = doc.users[action.user]) === null || _doc$users$action$use === void 0 ? void 0 : _doc$users$action$use.name) || '';
          var signed = verifyActionSignature(_this10.app, action, doc.users[action.user], doc);
          var kind = typeLabel(action.type, signed);
          return {
            id: action.id,
            page: action.page,
            type: action.type,
            name: name,
            color: signerColor(doc.users[action.user] ? action.user : doc.users.length),
            label: name ? "".concat(kind, " - ").concat(name, " - page ").concat(action.page) : "".concat(kind, " - page ").concat(action.page),
            signed: signed,
            active: selected(action.id),
            confirming: marked(action.id)
          };
        }),
        pages: Array.from({
          length: doc.document.page_count
        }, function (_, index) {
          var page = index + 1;
          return {
            page: page,
            editable: canConfigure(_this10.app, doc),
            fields: actionsOnPage(doc, page).map(function (action) {
              var _doc$users$action$use2;
              var name = ((_doc$users$action$use2 = doc.users[action.user]) === null || _doc$users$action$use2 === void 0 ? void 0 : _doc$users$action$use2.name) || '';
              var signed = verifyActionSignature(_this10.app, action, doc.users[action.user], doc);
              var kind = typeLabel(action.type, signed);
              return {
                id: action.id,
                type: action.type,
                name: name,
                label: name ? "".concat(kind, " - ").concat(name) : kind,
                signed: signed,
                color: signerColor(doc.users[action.user] ? action.user : doc.users.length),
                x: action.x,
                y: action.y,
                width: action.width,
                height: action.height,
                active: selected(action.id),
                confirming: marked(action.id)
              };
            }),
            draft: draft && draft.page === page ? draft : null
          };
        })
      };
    }
  }, {
    key: "paintFields",
    value: function paintFields(root, view) {
      view.pages.forEach(function (page) {
        var layer = root.querySelector(".pdf-page[data-page=\"".concat(page.page, "\"] .fields"));
        if (!layer) {
          return;
        }
        layer.classList.toggle('placing', view.placing);
        layer.classList.toggle('marking', view.can_edit);
        layer.innerHTML = WorkspaceTemplate.fields(page);
      });
    }

    // Each page is its own sheet. The plugin is loaded once, after the sheet has
    // a size, and is never torn down to change pages. Reloading one iframe with
    // `#page=N&zoom=page-fit` left the newly opened page blank: Chrome ignores
    // `zoom=page-fit` and paints a fragment target only after a resize, which
    // the old path never sent. Page numbers in the fragment are 1-based within
    // the source PDF that owns that continuous page.
  }, {
    key: "loadPages",
    value: function loadPages(root) {
      var _this11 = this;
      var doc = this.mod.document;
      var wrap = root.querySelector('.sheet-wrap');
      if (!hasPdf(doc) || !wrap) {
        return;
      }
      var wrapBox = wrap.getBoundingClientRect();
      var margin = wrapBox.height || 400;
      root.querySelectorAll('.pdf-page').forEach(function (pageEl) {
        var _source$entry;
        var frame = pageEl.querySelector('.page');
        if (!frame || frame.dataset.loaded) {
          return;
        }
        var box = pageEl.getBoundingClientRect();
        var page = Number(pageEl.dataset.page);
        var source = pageSource(doc, page);
        var near = box.bottom >= wrapBox.top - margin && box.top <= wrapBox.bottom + margin;
        if (!near && page !== _this11.page) {
          return;
        }
        if (box.width < 40 || box.height < 40 || !(source !== null && source !== void 0 && (_source$entry = source.entry) !== null && _source$entry !== void 0 && _source$entry.url)) {
          return;
        }
        frame.dataset.loaded = '1';
        frame.src = "".concat(source.entry.url, "#page=").concat(source.localPage, "&view=FitH&toolbar=0&navpanes=0");
        frame.addEventListener('load', function () {
          var width = frame.getBoundingClientRect().width;
          if (!width) {
            return;
          }
          frame.style.width = "".concat(Math.floor(width) - 1, "px");
          requestAnimationFrame(function () {
            frame.style.width = '';
          });
        }, {
          once: true
        });
      });
    }
  }, {
    key: "onScroll",
    value: function onScroll(root) {
      var _document$activeEleme;
      this.loadPages(root);
      if (this.suspend_scroll) {
        return;
      }
      var page = visiblePage(root);
      if (!page || page === this.page) {
        return;
      }
      this.page = page;
      if ((_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.matches('[data-page-input]')) {
        return;
      }
      root.querySelector('.reader').innerHTML = WorkspaceTemplate.reader(this.view());
    }
  }, {
    key: "scrollToField",
    value: function scrollToField(root, id) {
      var _window$matchMedia,
        _window,
        _this12 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var wrap = root.querySelector('.sheet-wrap');
      var el = root.querySelector(".pdf-page .field[data-field-id=\"".concat(CSS.escape(String(id)), "\"]"));
      if (!wrap || !el) {
        this.scrollToPage(root, this.page);
        return Promise.resolve();
      }
      var wrapBox = wrap.getBoundingClientRect();
      var box = el.getBoundingClientRect();
      var margin = 32;
      var viewTop = wrapBox.top + margin;
      var viewBottom = wrapBox.bottom - margin;
      var viewLeft = wrapBox.left + margin;
      var viewRight = wrapBox.right - margin;
      var preferTop = options.preferTop === true;
      var deltaY = 0;
      var deltaX = 0;
      if (preferTop) {
        var targetTop = wrapBox.top + Math.max(28, (viewBottom - viewTop) * 0.18);
        deltaY = box.top - targetTop;
        deltaX = box.left + box.width / 2 - (wrapBox.left + wrapBox.width / 2);
      } else {
        if (box.height >= viewBottom - viewTop) {
          deltaY = box.top - viewTop;
        } else if (box.top < viewTop) {
          deltaY = box.top - viewTop;
        } else if (box.bottom > viewBottom) {
          deltaY = box.bottom - viewBottom;
        }
        if (box.left < viewLeft) {
          deltaX = box.left - viewLeft;
        } else if (box.right > viewRight) {
          deltaX = box.right - viewRight;
        }
      }
      if (Math.abs(deltaX) < 2 && Math.abs(deltaY) < 2) {
        return Promise.resolve();
      }
      var top = wrap.scrollTop + deltaY;
      var left = wrap.scrollLeft + deltaX;
      var reduced = typeof window !== 'undefined' && ((_window$matchMedia = (_window = window).matchMedia) === null || _window$matchMedia === void 0 || (_window$matchMedia = _window$matchMedia.call(_window, '(prefers-reduced-motion: reduce)')) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches);
      var smooth = options.smooth === true && !reduced && typeof wrap.scrollTo === 'function';
      this.suspend_scroll = true;
      if (!smooth) {
        wrap.scrollTop = top;
        wrap.scrollLeft = left;
        this.loadPages(root);
        return new Promise(function (resolve) {
          requestAnimationFrame(function () {
            _this12.suspend_scroll = false;
            resolve();
          });
        });
      }
      return new Promise(function (resolve) {
        var settled = false;
        var _finish2 = function finish() {
          if (settled) {
            return;
          }
          settled = true;
          if (_this12.sign_scroll_wait === _finish2) {
            _this12.sign_scroll_wait = null;
          }
          clearTimeout(fallback);
          wrap.removeEventListener('scrollend', _finish2);
          _this12.suspend_scroll = false;
          _this12.loadPages(root);
          resolve();
        };
        var fallback = setTimeout(_finish2, 800);
        _this12.sign_scroll_wait = _finish2;
        wrap.addEventListener('scrollend', _finish2);
        wrap.scrollTo({
          top: top,
          left: left,
          behavior: 'smooth'
        });
      });
    }
  }, {
    key: "scrollToPage",
    value: function scrollToPage(root, page) {
      var _this13 = this;
      var wrap = root.querySelector('.sheet-wrap');
      var el = root.querySelector(".pdf-page[data-page=\"".concat(page, "\"]"));
      if (!wrap || !el) {
        return;
      }
      this.suspend_scroll = true;
      var top = el.getBoundingClientRect().top - wrap.getBoundingClientRect().top;
      wrap.scrollTop += top;
      this.loadPages(root);
      requestAnimationFrame(function () {
        _this13.suspend_scroll = false;
      });
    }
  }, {
    key: "changeZoom",
    value: function changeZoom(factor, root) {
      var wrap = root.querySelector('.sheet-wrap');
      var sheet = root.querySelector('.sheet');
      if (!wrap || !sheet) {
        return;
      }
      var next = clampZoom(this.zoom * factor, this.zoom_floor || ZOOM_MIN);
      if (next === this.zoom) {
        return;
      }
      var wrapBox = wrap.getBoundingClientRect();
      var before = sheet.getBoundingClientRect();
      var focusX = before.width ? (wrapBox.left + wrapBox.width / 2 - before.left) / before.width : 0.5;
      var focusY = before.height ? (wrapBox.top + wrapBox.height / 2 - before.top) / before.height : 0.5;
      this.zoom = next;
      this.fitSheet(root);
      var after = sheet.getBoundingClientRect();
      wrap.scrollLeft += after.left + after.width * focusX - (wrapBox.left + wrapBox.width / 2);
      wrap.scrollTop += after.top + after.height * focusY - (wrapBox.top + wrapBox.height / 2);
      root.querySelector('.reader').innerHTML = WorkspaceTemplate.reader(this.view());
    }
  }, {
    key: "fitSheet",
    value: function fitSheet(root) {
      var _doc$document,
        _doc$document2,
        _this14 = this;
      var stage = root.querySelector('.stage');
      var sheet = root.querySelector('.sheet');
      var doc = this.mod.document;
      var first = pdfEntries(doc)[0];
      var page_width = Number(first === null || first === void 0 ? void 0 : first.page_width) || Number(doc === null || doc === void 0 || (_doc$document = doc.document) === null || _doc$document === void 0 ? void 0 : _doc$document.page_width) || 0;
      var page_height = Number(first === null || first === void 0 ? void 0 : first.page_height) || Number(doc === null || doc === void 0 || (_doc$document2 = doc.document) === null || _doc$document2 === void 0 ? void 0 : _doc$document2.page_height) || 0;
      if (!stage || !sheet || !page_width || !page_height) {
        return;
      }
      var style = window.getComputedStyle(stage);
      var boundsW = stage.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      var boundsH = stage.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
      if (boundsW < 40 || boundsH < 40) {
        return;
      }
      var ratio = page_width / page_height;
      var available = Math.max(40, boundsW - 40);
      var widthFit = Math.min(available, 1280);
      var containWidth = Math.min(widthFit, Math.max(40, boundsH * ratio));
      this.zoom_floor = widthFit > 0 ? Math.min(1, containWidth / widthFit) : 1;
      if (this.zoom < this.zoom_floor) {
        this.zoom = this.zoom_floor;
      }
      sheet.style.width = "".concat(Math.floor(widthFit * this.zoom), "px");
      sheet.style.height = 'auto';
      sheet.querySelectorAll('.pdf-page').forEach(function (page) {
        var _source$entry2, _source$entry3;
        var source = pageSource(doc, Number(page.dataset.page));
        var width = Number(source === null || source === void 0 || (_source$entry2 = source.entry) === null || _source$entry2 === void 0 ? void 0 : _source$entry2.page_width) || page_width;
        var height = Number(source === null || source === void 0 || (_source$entry3 = source.entry) === null || _source$entry3 === void 0 ? void 0 : _source$entry3.page_height) || page_height;
        var pageRatio = width / height;
        page.style.height = "".concat(Math.floor(widthFit / pageRatio * _this14.zoom), "px");
      });
      this.seatReader(root);
    }
  }, {
    key: "seatReader",
    value: function seatReader(root) {
      var stage = root.querySelector('.stage');
      var sheet = root.querySelector('.sheet');
      var reader = root.querySelector('.reader');
      if (!stage || !sheet || !reader) {
        return;
      }
      if (!this.reader_moved) {
        reader.style.left = '';
        reader.style.top = '';
        reader.style.right = '';
        return;
      }
      var maxX = Math.max(8, stage.clientWidth - reader.offsetWidth - 8);
      var maxY = Math.max(8, stage.clientHeight - reader.offsetHeight - 8);
      this.reader_x = Math.min(maxX, Math.max(8, this.reader_x));
      this.reader_y = Math.min(maxY, Math.max(8, this.reader_y));
      reader.style.right = 'auto';
      reader.style.left = "".concat(this.reader_x, "px");
      reader.style.top = "".concat(this.reader_y, "px");
    }
  }, {
    key: "beginReaderDrag",
    value: function beginReaderDrag(event) {
      if (event.button !== 0 || event.target.closest('button, input, label')) {
        return;
      }
      var reader = event.currentTarget;
      this.reader_drag = {
        pointer: event.pointerId,
        dx: event.clientX - reader.offsetLeft,
        dy: event.clientY - reader.offsetTop
      };
      reader.setPointerCapture(event.pointerId);
      reader.classList.add('moving');
    }
  }, {
    key: "moveReader",
    value: function moveReader(event, root) {
      if (!this.reader_drag || this.reader_drag.pointer !== event.pointerId) {
        return;
      }
      this.reader_moved = true;
      this.reader_x = event.clientX - this.reader_drag.dx;
      this.reader_y = event.clientY - this.reader_drag.dy;
      this.seatReader(root);
    }
  }, {
    key: "endReaderDrag",
    value: function endReaderDrag(event) {
      if (!this.reader_drag || this.reader_drag.pointer !== event.pointerId) {
        return;
      }
      this.reader_drag = null;
      event.currentTarget.classList.remove('moving');
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this15 = this;
      if (this.listening || typeof window === 'undefined') {
        return;
      }
      this.listening = true;
      window.addEventListener('resize', function () {
        var root = document.querySelector('.saito-container > .workspace');
        if (root) {
          _this15.fitSheet(root);
          _this15.loadPages(root);
        }
      });
    }
  }]);
}();
function everyPageChecked(form, type) {
  var _form$querySelector1;
  return (type === 'signature' || type === 'initial') && Boolean(form === null || form === void 0 || (_form$querySelector1 = form.querySelector('[data-every-page]')) === null || _form$querySelector1 === void 0 ? void 0 : _form$querySelector1.checked);
}
function newActionGroup() {
  return "g".concat(Date.now().toString(36)).concat(Math.random().toString(36).slice(2, 6));
}
function placeConfiguredAction(doc, action, actorKey) {
  var _doc$document3;
  var everyPage = action.everyPage === true && (action.type === 'signature' || action.type === 'initial') && Number(doc === null || doc === void 0 || (_doc$document3 = doc.document) === null || _doc$document3 === void 0 ? void 0 : _doc$document3.page_count) > 1;
  if (!everyPage) {
    return addAction(doc, action, actorKey);
  }
  var group = newActionGroup();
  var count = Number(doc.document.page_count) || 0;
  var first = null;
  for (var page = 1; page <= count; page += 1) {
    var placed = addAction(doc, {
      type: action.type,
      user: action.user,
      page: page,
      x: action.x,
      y: action.y,
      width: action.width,
      height: action.height,
      group: group
    }, actorKey);
    if (!first) {
      first = placed;
    }
  }
  return first;
}
function syncGroupGeometry(doc, action, geometry) {
  var group = String((action === null || action === void 0 ? void 0 : action.group) || '').trim();
  var targets = group ? (doc.actions || []).filter(function (item) {
    return String(item.group || '').trim() === group;
  }) : [action];
  targets.forEach(function (item) {
    if (!item) {
      return;
    }
    if (geometry.x != null) {
      item.x = geometry.x;
    }
    if (geometry.y != null) {
      item.y = geometry.y;
    }
    if (geometry.width != null) {
      item.width = geometry.width;
    }
    if (geometry.height != null) {
      item.height = geometry.height;
    }
  });
}
function syncGroupFields(doc, action, fields) {
  var group = String((action === null || action === void 0 ? void 0 : action.group) || '').trim();
  var targets = group ? (doc.actions || []).filter(function (item) {
    return String(item.group || '').trim() === group;
  }) : [action];
  targets.forEach(function (item) {
    if (!item) {
      return;
    }
    if (fields.type != null) {
      item.type = fields.type;
    }
    if (fields.user != null) {
      item.user = fields.user;
    }
  });
}
function nextUnsignedAction(app, doc, userIndex, after) {
  var _doc$users2;
  var user = doc === null || doc === void 0 || (_doc$users2 = doc.users) === null || _doc$users2 === void 0 ? void 0 : _doc$users2[userIndex];
  if (!user) {
    return null;
  }
  var waiting = (doc.actions || []).filter(function (action) {
    return action.user === userIndex && (action.type === 'signature' || action.type === 'initial') && canSignAction(app, action, user, doc);
  }).sort(function (left, right) {
    return left.page - right.page || left.y - right.y || left.x - right.x || left.id - right.id;
  });
  if (!waiting.length) {
    return null;
  }
  if (!after) {
    return waiting[0];
  }
  var later = waiting.find(function (action) {
    return action.page > after.page || action.page === after.page && (action.y > after.y || action.y === after.y && action.x > after.x);
  });
  return later || waiting[0];
}
function signerRelation(app, user, record) {
  var theirs = String((user === null || user === void 0 ? void 0 : user.publickey) || '').trim();
  var recognized = Boolean(theirs && walletKeys(app).includes(theirs));
  return {
    bound: Boolean(theirs),
    recognized: recognized,
    verified: recognized && verificationSatisfied(app, record, user)
  };
}
function duplicateSignerNotice() {
  if (typeof siteMessage === 'function') {
    siteMessage('Adding multiple users with the same email address is not permitted.', 3000);
  }
}
function clampZoom(value) {
  var floor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ZOOM_MIN;
  var zoom = Math.round(value * 100) / 100;
  return Math.min(ZOOM_MAX, Math.max(floor, zoom));
}
function signerColor(index) {
  var n = Number(index);
  if (!Number.isInteger(n) || n < 0) {
    return '#6b625b';
  }
  return SIGNER_COLORS[n % SIGNER_COLORS.length];
}
function typeLabel(type, signed) {
  if (type === 'date') {
    return signed ? 'dated' : 'date / time';
  }
  if (type === 'initial') {
    return signed ? 'initialed' : 'initial';
  }
  return signed ? 'signed' : 'signature';
}
function nearSize(value, expected) {
  return Math.abs(Number(value) - Number(expected)) < 0.001;
}
function isDefaultSignatureSize(box) {
  return nearSize(box === null || box === void 0 ? void 0 : box.width, CLICK_WIDTH) && nearSize(box === null || box === void 0 ? void 0 : box.height, CLICK_HEIGHT);
}
function geometryForNewField(type, box) {
  if (type !== 'initial' || !isDefaultSignatureSize(box)) {
    return {
      x: box.x,
      y: box.y,
      width: box.width,
      height: box.height
    };
  }
  var size = CLICK_HEIGHT;
  var cx = box.x + box.width / 2;
  var cy = box.y + box.height / 2;
  return fitBox({
    x: cx - size / 2,
    y: cy - size / 2,
    width: size,
    height: size
  });
}
function defaultFieldBox(drag, clientX, clientY, type) {
  var box = drag.box;
  var height = CLICK_HEIGHT;
  var width = type === 'initial' ? CLICK_HEIGHT : CLICK_WIDTH;
  var cx = (clientX - box.left) / box.width;
  var cy = (clientY - box.top) / box.height;
  return fitBox({
    x: cx - width / 2,
    y: cy - height / 2,
    width: width,
    height: height
  });
}
function placeBox(start, x, y) {
  var width = start.width;
  var height = start.height;
  return {
    x: Math.min(Math.max(0, x), Math.max(0, 1 - width)),
    y: Math.min(Math.max(0, y), Math.max(0, 1 - height)),
    width: width,
    height: height
  };
}
function pointerFraction(box, clientX, clientY) {
  return {
    x: (clientX - box.left) / box.width,
    y: (clientY - box.top) / box.height
  };
}
function resizeBox(start, edge, px, py) {
  var left = start.x;
  var top = start.y;
  var right = start.x + start.width;
  var bottom = start.y + start.height;
  var x = clamp01(px);
  var y = clamp01(py);
  if (String(edge).includes('w')) {
    left = x;
  }
  if (String(edge).includes('e')) {
    right = x;
  }
  if (String(edge).includes('n')) {
    top = y;
  }
  if (String(edge).includes('s')) {
    bottom = y;
  }
  return fitBox({
    x: Math.min(left, right),
    y: Math.min(top, bottom),
    width: Math.abs(right - left),
    height: Math.abs(bottom - top)
  });
}
function fitBox(box) {
  var x = box.x;
  var y = box.y;
  var width = Math.max(box.width, MIN_BOX_WIDTH);
  var height = Math.max(box.height, MIN_BOX_HEIGHT);
  if (width > 1) {
    width = 1;
  }
  if (height > 1) {
    height = 1;
  }
  x = Math.min(Math.max(0, x), 1 - width);
  y = Math.min(Math.max(0, y), 1 - height);
  return {
    x: x,
    y: y,
    width: width,
    height: height
  };
}
function rectangle(drag, clientX, clientY) {
  var box = drag.box;
  var x0 = (drag.x0 - box.left) / box.width;
  var y0 = (drag.y0 - box.top) / box.height;
  var x1 = (clientX - box.left) / box.width;
  var y1 = (clientY - box.top) / box.height;
  var left = clamp01(Math.min(x0, x1));
  var top = clamp01(Math.min(y0, y1));
  var right = clamp01(Math.max(x0, x1));
  var bottom = clamp01(Math.max(y0, y1));
  var width = right - left;
  var height = bottom - top;
  return {
    x: left,
    y: top,
    width: width,
    height: height,
    pixels: Math.max(Math.abs(clientX - drag.x0), Math.abs(clientY - drag.y0))
  };
}
function paintDraft(stage, draft) {
  var mark = stage.querySelector('.draft');
  if (!mark) {
    mark = document.createElement('div');
    mark.className = 'field draft active';
    stage.appendChild(mark);
  }
  mark.style.left = "".concat((draft.x * 100).toFixed(2), "%");
  mark.style.top = "".concat((draft.y * 100).toFixed(2), "%");
  mark.style.width = "".concat((draft.width * 100).toFixed(2), "%");
  mark.style.height = "".concat((draft.height * 100).toFixed(2), "%");
}
function visiblePage(root) {
  var wrap = root.querySelector('.sheet-wrap');
  var pages = _toConsumableArray(root.querySelectorAll('.pdf-page'));
  if (!wrap || !pages.length) {
    return 0;
  }
  var marker = wrap.getBoundingClientRect().top + Math.min(96, wrap.clientHeight * 0.28);
  var current = Number(pages[0].dataset.page);
  pages.forEach(function (page) {
    if (page.getBoundingClientRect().top <= marker) {
      current = Number(page.dataset.page);
    }
  });
  return current;
}
function userIdentity(signer) {
  var name = String((signer === null || signer === void 0 ? void 0 : signer.name) || '').trim();
  var email = String((signer === null || signer === void 0 ? void 0 : signer.email) || '').trim();
  if (email || !isEmailAddress(name)) {
    return {
      name: name,
      email: email
    };
  }
  return {
    name: nameFromEmail(name),
    email: name
  };
}
function isEmailAddress(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
function nameFromEmail(email) {
  return email.split('@')[0].replace(/[._+-]+/g, ' ').replace(/\s+/g, ' ').trim();
}
function clampPage(value, count, fallback) {
  var page = Number(value);
  if (!Number.isFinite(page)) {
    return fallback;
  }
  return Math.min(count, Math.max(1, Math.round(page)));
}
function clamp01(value) {
  return Math.min(1, Math.max(0, value));
}
module.exports = Workspace;